import { localStorageService, StorageKeys } from '../storageService';
export function saveDeepLinkToStorage(data) {
    const storageData = {
        ...data,
        timestamp: Date.now(),
    };
    localStorageService.setItemSync(StorageKeys.DeepLinkData, storageData);
}
export function getDeepLinkFromStorage() {
    return localStorageService.getItemSync(StorageKeys.DeepLinkData);
}
export function clearDeepLinkStorage() {
    localStorageService.removeItem(StorageKeys.DeepLinkData);
}
export function hasDeepLinkStored() {
    return getDeepLinkFromStorage() !== null;
}
